import { Skeleton } from './ui/index.jsx'

export default function RouteLoadingSkeleton() {
  return (
    <div style={{ padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Skeleton height={28} width={220} />
      <Skeleton height={16} width={360} />
      <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <Skeleton height={48} style={{ borderRadius: 8 }} />
        <Skeleton height={48} style={{ borderRadius: 8 }} />
        <Skeleton height={48} style={{ borderRadius: 8 }} />
      </div>
    </div>
  )
}
